import React from "react";
import styled from "styled-components";

import { ChipsRail, SoftChip } from "../Workspace/UriTable/TableFilters";
import { ACCENT } from "./accent";

/**
 * What applies to the breakdown and the list alike, above both: the active filters, each a filled
 * chip that clears it, and an action clearing them all.
 */
export default function Controls({ filters, onClearFilters }) {
    if (filters.length === 0) return null;
    return (
        <Bar>
            <Filters aria-live="polite">
                {filters.map(({ label, onDelete }) => (
                    <FilterChip key={label} label={label} onDelete={onDelete} size="small" variant="default" />
                ))}
                <ClearFilters type="button" onClick={onClearFilters}>Clear filters</ClearFilters>
            </Filters>
        </Bar>
    );
}

const Bar = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    margin: 0 0 12px;
    @media (max-width: 600px) { padding: 0 16px; }
`;

/** Wraps rather than scrolling sideways, so Clear filters stays in view on a phone. */
const Filters = styled(ChipsRail)`
    flex-wrap: wrap;
    min-width: 0;
    max-width: 100%;
    overflow: visible;
    white-space: normal;
`;

const FilterChip = styled(SoftChip)`
    && {
        max-width: 100%;
        background: ${ACCENT};
        border-color: ${ACCENT};
        color: #fff;
        .MuiChip-deleteIcon { color: #ffffffb3; }
        .MuiChip-deleteIcon:hover { color: #fff; }
    }
`;

const ClearFilters = styled.button`
    padding: 2px 4px;
    border: none;
    background: none;
    font: inherit;
    font-size: 0.75rem;
    font-weight: 600;
    color: ${ACCENT};
    cursor: pointer;
    &:hover { text-decoration: underline; }
`;
